/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

import { PaymentFormCloseIcon } from 'assets/img/icons/icons';
import './payment.scss';

interface PaymentFormItem {
  img: string;
  totalPrice?: number;
  payment_method_pid: number;
  payment_type_pid: number;
}

interface PaymentFormsProps {
  paymentFormsData: PaymentFormItem[];
  setPaymentFormsData: (data: PaymentFormItem[]) => void;
  amounts: { [key: string]: number };
  setAmounts?: any;
}

const PaymentForms = ({
  paymentFormsData,
  setPaymentFormsData,
  amounts,
  setAmounts
}: PaymentFormsProps) => {
  const formatNumber = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      useGrouping: true
    })
      .format(value)
      .replace(/,/g, ' ');
  };

  // Handle input change and store raw number
  const handleInputChange = (index: string, value: string) => {
    const numValue = value === '' ? 0 : Number(value.replace(/[^0-9.]/g, ''));
    setAmounts((prev: any) => ({ ...prev, [index]: numValue }));
  };

  const handleRemoveForm = (index: number) => {
    const updatedData = paymentFormsData?.filter((_, i) => i !== index);
    setPaymentFormsData(updatedData);

    // Update amounts to remove the corresponding entry
    const keyToRemove = `${paymentFormsData[index]?.img}-${index}`;
    setAmounts((prev: any) => {
      const newAmounts = { ...prev };
      delete newAmounts[keyToRemove];
      return newAmounts;
    });
  };

  // Initialize amounts with totalPrice from paymentFormsData
  useEffect(() => {
    const initialAmounts: { [key: string]: number } = {};
    paymentFormsData?.forEach((item, index) => {
      const key = `${item.img}-${index}`;
      initialAmounts[key] = item.totalPrice || 0;
    });
    setAmounts(initialAmounts);
  }, [paymentFormsData]);

  const filteredPaymentForms = () => {
    const pid5Forms: PaymentFormItem[] = [];
    const otherPidForms: { [key: number]: PaymentFormItem[] } = {};

    paymentFormsData.forEach(item => {
      if (item.payment_method_pid === 5 && pid5Forms.length < 2) {
        pid5Forms.push(item);
      } else if (item.payment_method_pid !== 5) {
        // Initialize array for this pid if not exists
        if (!otherPidForms[item.payment_method_pid]) {
          otherPidForms[item.payment_method_pid] = [];
        }
        // Add item if under the limit of 3 for this pid
        if (otherPidForms[item.payment_method_pid].length < 3) {
          otherPidForms[item.payment_method_pid].push(item);
        }
      }
    });

    // Combine pid5 forms with all other pid forms
    const allOtherForms = Object.values(otherPidForms).flat();
    return [...pid5Forms, ...allOtherForms];
  };

  const displayedForms = filteredPaymentForms();

  return (
    <div className="payment-forms">
      {displayedForms?.map((items: PaymentFormItem, index) => {
        const key = `${items.img}-${index}`;
        return (
          <div key={key} className="payment-form">
            <div className="payment-form-group">
              <div className="payment-form-icon">
                <img src={items?.img} alt="type" />
              </div>
              <input
                type="text"
                placeholder="Amount"
                aria-label="Amount in UZS"
                min="0"
                step="0.01"
                value={
                  amounts[key] !== undefined ? formatNumber(amounts[key]) : ''
                }
                onChange={e => handleInputChange(key, e.target.value)}
                onFocus={e => e.target.select()}
              />
              <span className="payment-form-currency">UZS</span>
            </div>
            <div
              className="payment-form-close"
              onClick={() => handleRemoveForm(index)}
            >
              <PaymentFormCloseIcon />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PaymentForms;
